<template>
  <div class="alter-teacher">
    <div class="alter-teacher-top">
      <Header title="选择教材"></Header>
      <NOdata v-if="this.jcList.length == 0" title="未查询到教材信息"></NOdata>
      <template v-else>
        <div class="alter-item" v-for="(item,index) in jcList" :key="index">
          <div>
            <h4>{{item.jcmc}}</h4>
            <p>ISBN书号:{{item.isbn}}</p>
            <p>作者:{{item.jczz}}</p>
            <p>版次:{{item.jcbc}}</p>
            <p>出版社:{{item.cbsmc}}</p>
            <p>单价:{{item.jcdj}}</p>
          </div>
          <van-checkbox v-model="item.checked"  v-if="item.isxz == '0'" checked-color="#7469F8"  @click="xzjc(item.checked,item.jcsmid)"></van-checkbox>
          <button v-if="item.isxz != '0'" class="eva-btn"  @click="txjc(item)">退选</button>
        </div>
      </template>
    </div>
    <div class="alter-buttons">
      <button class="clear" @click="clear()">取消</button>
      <button class="confirm"  @click="select()">选中</button>
    </div>
  </div>
</template>
<script>
import { Api } from '../../../utils/axios'
export default {
  props: {
    isRadio:{
      type:Boolean,
      default:false
    },
    list:{
      type:Array,
      default:() => []
    }
  },
  data(){
    return{
      jcList:[],
      xzjcList:[],
      jx02id:'',
      xnxq01id:'',
      jx0404id:'',
      jx0501id:''
    }
  },
  created(){
    this.getJcList()
  },
  methods:{
    async xzjc(checked,jcsmid){
      if(checked){
        this.xzjcList.push(jcsmid);
      }else{
        this.xzjcList.splice(this.xzjcList.indexOf(jcsmid), 1);
      }
    },
    async select(){
      var jcsmids = '';
      this.xzjcList.forEach(item => {
        jcsmids +=item+','
      });
      let param = {
        jx02id: this.jx02id,
        xnxq01id: this.xnxq01id,
        jx0404id: this.jx0404id,
        jx0501id: this.jx0501id,
        jcsmids: jcsmids
      };
      const res = await Api.saveXkjc(param)
      if(res.code == '0'){
        this.$toast.fail(res.Msg);
      }else{
        this.$toast.success(res.Msg);
        this.getJcList();
      }
    },
    async txjc(item){
      let param = {
        jx02id: this.jx02id,
        xnxq01id: this.xnxq01id,
        jx0404id: this.jx0404id,
        jx0501id: this.jx0501id,
        jcsmid: item.jcsmid
      };
      const res = await Api.delkjc(param)
      if(res.code == '0'){
        this.$toast.fail(res.Msg);
      }else{
        this.$toast.success(res.Msg);
        this.getJcList();
      }
    },
    clear(){
      this.$router.back()
    },
    async getJcList(){
      const query = JSON.parse(this.$route.query.info);
      const res = await Api.xsxkXzjc(query)
      this.jcList =  res.data;
      this.jx02id = query.JX02ID;
      this.xnxq01id = query.XNXQ01ID;
      this.jx0404id = query.JX0404ID;
      this.jx0501id = query.JX0501ID;
    }
  }
}
</script>
<style lang="less">
.alter-teacher{
  padding: 0 20px;
  margin: 0px 0 20px;
  .alter-teacher-top{
    overflow: auto;
    height: 700px;
    .alter-item{
      padding: 0 20px;
      background-color: @attendance-background-color-10;
      border-radius:5px;height: 152px;margin: 21px 0 13px;
      display: flex;justify-content: space-between;align-items: center;
      h4{
        color: @attendance-color-1;font-size: 16px;line-height: 22px;margin-bottom: 8px;
      }
      p{
        color: @attendance-color-2;font-size: 12px;line-height: 17px;
      }
      /deep/.el-checkbox__inner{
        width: 18px;height: 18px;
        border-radius: 50%;
        border: 2px solid @attendance-border-color-4;
        &::after{
          left: 5px;top: 2px;border-width: 2px;
        }
      }
      /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
        background: @attendance-background-color-1;
        border-color:@attendance-background-color-1;
      }

      button.eva-btn{
        background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;padding: 11px 0px;box-sizing: border-box;width: 75px;
      }
    }
  }
  
  
}
.alter-buttons{
    z-index: 9;
    background-color: @attendance-color-3;
    position: fixed;bottom: 0;padding: 20px 0;
    width: calc(~"100% - 40px");box-sizing: border-box;
    display: flex;justify-content: space-between;align-items: center;
    button{
      width: calc(~"50% - 10px");padding: 11px 0;border-radius: 3px;
    }
    button.clear{
      background-color: @attendance-background-color-7;
      color: @attendance-background-color-1;
    }
    button.confirm{
      background-color: @attendance-background-color-1;
      color: @attendance-color-3;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/student/jcdg/xsxkjcDg_jcxz.vue